const {

    slugifyProductFields,

    buildProvisionalProductSlug,

    extractProductIdFromProvisionalSlug,

    buildCategoryPath,

    buildProvisionalProductPath,

    getProductCategoryPath,

    productMatchesCategory

} = require ( "./ProvisionalProductUrl" );

const

/** @return Single tyre permalink */

TyrePermalinks = product => buildProvisionalProductPath ( { ...product, productType: product.productType || "tire" } ),

/** @return Single rim permalink */



RimPermalinks = product => buildProvisionalProductPath ( { ...product, productType: product.productType || "rim" } ),

/** @return Single battery permalink */

BatteryPermalinks = product => buildProvisionalProductPath ( { ...product, productType: product.productType || "battery" } );

/** Export misc */

export {

    TyrePermalinks,

    RimPermalinks,

    BatteryPermalinks,

    slugifyProductFields,

    buildProvisionalProductSlug,

    extractProductIdFromProvisionalSlug,

    buildCategoryPath,

    buildProvisionalProductPath,

    getProductCategoryPath,

    productMatchesCategory

}